// import { Button } from "./Button";
// import { Input } from "./Input";
import { Modal } from "./Modal";
// import { ReactComponent as DemoMan } from "../../assets/icons/demoMan.svg";
// import { PopupModal, useCalendlyEventListener } from "react-calendly";
// import { useRequestDemoTriggerForAdminMutation } from "../../store/Company/companyApiSlice";
// import { useEffect, useState } from "react";
// import { CommonToast } from "./Toast";
import HubSpotForm from "./HubSpotForm";

const DemoModal = ({
    showDemoModal,
    setShowDemoModal
}) => {
    // const [showDemoModal, setShowDemoModal] = useState(false)
    // const [requestDemoTriggerForAdmin] = useRequestDemoTriggerForAdminMutation()
    // const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
    // const [demoDetails, setDemoDetails] = useState({
    //     name: "",
    //     email: "",
    //     designation: "",
    //     company_name: ""
    // });
    // const [errors, setErrors] = useState({
    //     name: "",
    //     email: "",
    //     designation: "",
    //     company_name: ""
    // })

    // const resetForm = () => {
    //     setDemoDetails({
    //         name: "",
    //         email: "",
    //         designation: "",
    //         company_name: ""
    //     });
    //     setErrors({
    //         name: "",
    //         email: "",
    //         designation: "",
    //         company_name: ""
    //     });
    // }

    const handleDemoModalClose = () => {
        // resetForm();
        setShowDemoModal(false)
    }
    // const handleIsScheduled = async (e) => {
    //     try {
    //         if (e.data) {
    //             const response = await requestDemoTriggerForAdmin({
    //                 requestData: demoDetails
    //             });
    //             if (response) {
    //                 setShowDemoModal(false);
    //                 CommonToast.success("Demo scheduled successfully")
    //             }
    //         }
    //     } catch (error) {
    //         CommonToast.error("Demo scheduled failed")
    //     } finally {
    //         resetForm();
    //     }
    // }
    // useCalendlyEventListener({
    //     onEventScheduled: (e) => handleIsScheduled(e),
    // });
    // const handleDemoValueSelect = (e) => {
    //     const { name, value } = e.target;
    //     setErrors(prevErrors => ({
    //         ...prevErrors,
    //         [name]: value ? "" : prevErrors[name]
    //     }));

    //     setDemoDetails(prevDetails => ({
    //         ...prevDetails,
    //         [name]: value
    //     }));
    // };

    // const validateForm = () => {
    //     let formIsValid = true;
    //     let newErrors = {};

    //     if (!demoDetails.name) {
    //         newErrors.name = "Name is required";
    //         formIsValid = false;
    //     }

    //     if (!demoDetails.email) {
    //         newErrors.email = "Email is required";
    //         formIsValid = false;
    //     } else if (!/\S+@\S+\.\S+/.test(demoDetails.email)) {
    //         newErrors.email = "Please enter a valid email";
    //         formIsValid = false;
    //     }

    //     if (!demoDetails.designation) {
    //         newErrors.designation = "Designation is required";
    //         formIsValid = false;
    //     }

    //     if (!demoDetails.company_name) {
    //         newErrors.company_name = "Company name is required";
    //         formIsValid = false;
    //     }
    //     setErrors(newErrors);
    //     return formIsValid;
    // };

    // const handleDemoSubmit = () => {
    //     if (validateForm()) {
    //         setIsCalendlyOpen(true);
    //     }
    // }
        

    return (
        <>
        {/* <div class="hs-form-frame" data-region="na1" data-form-id="dde1e0f0-9135-49e3-82ae-de9a39f2f768" data-portal-id="49334692"></div> */}
            {showDemoModal && (
                <Modal modalHandle={handleDemoModalClose}>
                    <div className="w-[700px]">
                    <HubSpotForm showDemoModal={showDemoModal}/>
                    </div>
                    {/* <div className="flex flex-col items-center mt-10 text-secondarytwo gap-3">
                        <DemoMan className="w-[229px] h-[179px]" />
                        <div>
                            <p className="font-semibold text-f20 mb-1">Transform Your Business with TREVEX!</p>
                            <p className="w-[483px] text-secondary">
                                Schedule your free demo now and discover how TREVEX can drive growth and streamline operations.
                            </p>
                        </div>
                        <div className="w-full">
                            <Input
                                classes="w-full pt-3 pb-1 text-sm text-primary placeholder-gray-400 border-b border-secondaryTwo/2 focus:border-secondaryTwo focus:outline-none focus:bg-white"
                                error={errors.name}
                                name="name"
                                placeholder="Name"
                                onInputChange={(e) => handleDemoValueSelect(e)}
                                value={demoDetails?.name}
                            />
                            <Input
                                classes="w-full pt-3 pb-1 text-sm text-primary placeholder-gray-400 border-b border-secondaryTwo/2 focus:border-secondaryTwo focus:outline-none focus:bg-white"
                                error={errors.email}
                                name="email"
                                placeholder="Email"
                                onInputChange={(e) => handleDemoValueSelect(e)}
                                value={demoDetails?.email}
                            />
                            <Input
                                classes="w-full pt-3 pb-1 text-sm text-primary placeholder-gray-400 border-b border-secondaryTwo/2 focus:border-secondaryTwo focus:outline-none focus:bg-white"
                                error={errors.company_name}
                                name="company_name"
                                placeholder="Company Name"
                                onInputChange={(e) => handleDemoValueSelect(e)}
                                value={demoDetails?.company_name}
                            />
                            <Input
                                classes="w-full pt-3 pb-1 text-sm text-primary placeholder-gray-400 border-b border-secondaryTwo/2 focus:border-secondaryTwo focus:outline-none focus:bg-white"
                                error={errors.designation}
                                name="designation"
                                placeholder="Designation"
                                onInputChange={(e) => handleDemoValueSelect(e)}
                                value={demoDetails?.designation}
                            />
                        </div>
                        <Button
                            onClick={handleDemoSubmit}
                            classes="w-full text-white bg-primary font-medium rounded text-sm py-3"
                        >
                            Proceed
                        </Button>
                    </div> */}
                </Modal>
            )}
            {/* <PopupModal
                url={process.env.REACT_APP_CALENDLY_URL}
                prefill={{
                    name: demoDetails?.name,
                    email: demoDetails?.email,
                    // customAnswers: {
                    //   a1: demoDetails?.company_name,
                    // },
                }}
                onModalClose={() => setIsCalendlyOpen(false)}
                open={isCalendlyOpen}
                rootElement={document.getElementById("root")}
            /> */}
        </>
    );
};

export default DemoModal;
